<template>
  <div ref="vueRemove">
    <!-- PayNull placeholder -->
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },

    paymentProviderPublicOptions: {
      type: [Array, Object],
      default: null,
    },
  },

  data() {
    return {

    };
  },

  methods: {
    /* ===============
     * public methods
     */

    takeSalePayment(sale, allowDepositFlag) {
      return null;
    },

    takeBookingPayment(booking) {
      return null;
    },

    takeVoucherPayment(voucher) {
      return null;
    },

    takeVirtualGamePayment(virtualGame, sale, from) {
      return null;
    },

    /*
     * END public methods
     * =============== */
  },

  mounted() {
    this.$nextTick(function () {
      $(this.$refs.vueRemove).contents().unwrap();
    });
  },
}
</script>
